<template>
  <v-card>
    <v-toolbar flat dense class="card-bar">
      <v-toolbar-title>Comparador</v-toolbar-title>
      <v-btn icon small class="ml-2" @click="reload">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <OLoadingLine absolute :value="isLoading" />

    <v-card-text class="">
      <v-select
        v-model="information"
        :items="availableInfos"
        label="Informação"
      />
    </v-card-text>

    <v-simple-table dense class="fixed-table dense-table">
      <template v-slot:default>
        <colgroup>
          <col width="100" />
          <col width="50" />
          <col width="90" />
          <col width="90" />
        </colgroup>
        <thead>
          <tr>
            <th class="text-right">ID</th>
            <th class="text-center">St.</th>
            <th class="text-right">Criado</th>
            <th class="text-right">Entregue</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="compiledMain != null">
            <td colspan="4">Compilado em {{ compiledMain.org.name }}</td>
            <td class="text-right">
              <v-btn icon @click="select(1, compiledMain)">
                <v-icon v-if="panel1id == compiledMain.id"
                  >mdi-numeric-1-circle</v-icon
                >
                <v-icon v-else>mdi-numeric-1</v-icon>
              </v-btn>
              <v-btn icon class="ml-2" @click="select(2, compiledMain)">
                <v-icon v-if="panel2id == compiledMain.id"
                  >mdi-numeric-2-circle</v-icon
                >
                <v-icon v-else>mdi-numeric-2</v-icon>
              </v-btn>
            </td>
          </tr>

          <tr v-if="compiledHlg != null">
            <td colspan="4">Compilado em {{ compiledHlg.org.name }}</td>
            <td class="text-right">
              <v-btn icon @click="select(1, compiledHlg)">
                <v-icon v-if="panel1id == compiledHlg.id"
                  >mdi-numeric-1-circle</v-icon
                >
                <v-icon v-else>mdi-numeric-1</v-icon>
              </v-btn>
              <v-btn icon class="ml-2" @click="select(2, compiledHlg)">
                <v-icon v-if="panel2id == compiledHlg.id"
                  >mdi-numeric-2-circle</v-icon
                >
                <v-icon v-else>mdi-numeric-2</v-icon>
              </v-btn>
            </td>
          </tr>

          <tr v-for="item in items" :key="item.id">
            <td class="text-right">{{ item.id }}</td>
            <td class="text-center">
              <v-icon :class="item.icon.class">{{ item.icon.text }}</v-icon>
            </td>
            <td class="text-right">
              <span :title="item.createdAt | moment">
                {{ item.createdAt | smallDate }}
              </span>
            </td>
            <td class="text-right">
              <span v-if="item.deliveredAt == null">-</span>
              <span v-else :title="item.deliveredAt | moment">{{
                item.deliveredAt | smallDate
              }}</span>
            </td>
            <td class="text-right">
              <v-btn icon @click="select(1, item)">
                <v-icon v-if="panel1id == item.id">mdi-numeric-1-circle</v-icon>
                <v-icon v-else>mdi-numeric-1</v-icon>
              </v-btn>
              <v-btn icon class="ml-2" @click="select(2, item)">
                <v-icon v-if="panel2id == item.id">mdi-numeric-2-circle</v-icon>
                <v-icon v-else>mdi-numeric-2</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="h-row pa-3">
      <v-spacer />

      <div class="px-4 caption text-right">
        {{ firstIndexShown }} ─ {{ lastIndexShown }}
        <span v-if="count != null">de {{ count }}</span>
      </div>

      <div class="pr-3 text-right">
        <v-btn icon :disabled="nav.offset < 1" @click="nav.offset = prevOffset">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn icon :disabled="!hasMore" @click="nav.offset = nextOffset">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'
import { MailboxItem, Org } from '@/models'
import { hasTag } from 'oderon-commons/src/utils'

const check = 'mdi-checkbox-marked-circle',
  cross = 'mdi-close-circle',
  wait = 'mdi-dots-horizontal-circle',
  green = 'green--text icon-small',
  red = 'red--text icon-small',
  yellow = 'orange--text icon-small',
  delivered = { text: check, class: green },
  pending = { text: wait, class: yellow },
  cancelled = { text: cross, class: red }

export default {
  components: {
    OLoadingLine: require('oderon-vue/cpts/OLoadingLine').default
  },
  props: {
    client: { required: true }
  },
  data() {
    return {
      availableInfos: [
        { text: 'Motoristas', value: 'driverSet' },
        { text: 'EIs', value: 'embeddedRulesSet' },
        { text: 'Polígonos', value: 'polygonSet' }
      ],

      allOrgs: [],

      isLoading: false,
      information: null,
      panel1id: null,
      panel2id: null,

      items: [],
      count: 0,
      nav: {
        limit: 10,
        offset: 0
      }
    }
  },
  computed: {
    apiParams() {
      return {
        limit: this.nav.limit,
        offset: this.nav.offset,
        information: this.information,
        clientIds: this.client.id
      }
    },

    compiledMain() {
      let mainOrg = this.allOrgs.find(o => o.id == this.client.organizationId)
      if (mainOrg == null) return null

      if (!hasTag(mainOrg.extraInfo, 'v4')) return null

      return {
        id: 'compiledMain',
        org: mainOrg,
        clientId: this.client.id,
        vehicleId: this.client.vehicleId,
        information: this.information
      }
    },

    compiledHlg() {
      let hlgOrg = this.allOrgs.find(o => {
        return (
          o.name.startsWith(this.client.organization.name) &&
          o.name.endsWith('hlg')
        )
      })

      if (hlgOrg == null) return null

      if (!hasTag(hlgOrg.extraInfo, 'v4')) return null

      return {
        id: 'compiledHlg',
        org: hlgOrg,
        clientId: this.client.id,
        vehicleId: this.client.vehicleId,
        information: this.information
      }
    },

    firstIndexShown() {
      return this.nav.offset + 1
    },
    lastIndexShown() {
      if (this.count == null) return this.nextOffset
      else return Math.min(this.nextOffset, this.count)
    },
    prevOffset() {
      return this.nav.offset - this.nav.limit
    },
    nextOffset() {
      return this.nav.offset + this.nav.limit
    },
    hasMore() {
      if (this.count == null) return true
      else return this.nextOffset <= this.count
    }
  },
  watch: {
    apiParams() {
      this.reload()
    },

    information() {
      this.panel1id = null
      this.panel2id = null
      this.nav.offset = 0
      this.$emit('select', { panel: 1, item: null })
      this.$emit('select', { panel: 2, item: null })
    }
  },
  methods: {
    async reload() {
      this.$loading(() => this.fetchItems())
    },

    async fetchItems() {
      if (this.apiParams.information == null) return null

      this.allOrgs = await Org.findAll()

      let res = await MailboxItem.findAll(this.apiParams)

      for (let r of res.rows) {
        r.icon = pending
        if (r.deletedAt != null) r.icon = cancelled
        if (r.deliveredAt != null) r.icon = delivered
      }

      this.items = res.rows
      this.count = res.count
    },

    select(panel, item) {
      if (panel == 1) this.panel1id = item.id
      else this.panel2id = item.id
      this.$emit('select', { panel, item })
    }
  },
  filters: {
    smallDate(x) {
      return moment(x).format('DD/MMM HH:mm')
    }
  }
}
</script>

<style></style>
